export const checkUserPermissions = (requiredPermissions: string[]): boolean => {
    if (requiredPermissions.length === 0) return true;
    
    try {
      const userPermissions = JSON.parse(localStorage.getItem("permissions") || "[]");
      return requiredPermissions.every(permission => 
        userPermissions.includes(permission)
      );
    } catch (error) {
      console.error("Error checking permissions:", error);
      return false;
    }
  };